<template>

<router-link :to="{name: 'Home'}" class="logo">
	<span>Find it Score it</span>
</router-link>

</template>

<script>

export default {

}

</script>

<style scoped>

.logo {
	display: block;
	position: absolute;
	left: 50%;
	top: 0px;
	margin-left: -100px;
	height: 64px;
	width: 200px;
	background-size: auto 49px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/logo.png);	
}

.logo span {
	visibility: hidden;
}

.is-mobile .logo {
    width: 130px;
    left: 8px;
    margin-left: 0px;
    background-size: contain;
    background-position: 0px 50%;
}

</style>